import { useState, useEffect, useMemo, useCallback } from 'react';
import { API } from '../api/config';

const isLocalhost = window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1' ||
        window.location.protocol === 'file:';

    // Use local API URL if running on localhost, otherwise use production URL
//const API_BASE_URL = isLocalhost
 //   ? 'http://localhost:8080' // Local development URL
//    : 'https://ry28naly3m.execute-api.us-east-1.amazonaws.com/estoque'; // Production URL

const API_BASE_URL = API.ESTOQUE;

export function useMenu() {
    const [allDishes, setAllDishes] = useState([]); 
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchMenu = async () => {
            setIsLoading(true);
            setError(null);
            try {
                const response = await fetch(`${API_BASE_URL}/cardapio/`);
                if (!response.ok) throw new Error(`HTTP error!`);
                
                const data = await response.json();
                console.log(data)
                setAllDishes(data || []);
            } catch (err) {
                console.error("Erro ao buscar cardápio:", err);
                setError("Não foi possível carregar o cardápio.");
            } finally {
                setIsLoading(false);
            }
        };
        fetchMenu();
    }, []);

    // --- CORREÇÃO 1: LÓGICA DE EXTRAIR categorias ---
    const categories = useMemo(() => {
        const categorySet = new Set();
        allDishes.forEach(dish => {
            // Verifica se 'categorias' (maiúsculo) existe e é um array
            if (dish.categorias && Array.isArray(dish.categorias)) {
                // Itera sobre o array de categorias do prato
                dish.categorias.forEach(category => {
                    categorySet.add(category);
                });
            }
        });
        
        // Ordena alfabeticamente para consistência
        const sortedCategories = Array.from(categorySet).sort();
        return ['all', ...sortedCategories];
    }, [allDishes]);

    // --- CORREÇÃO 2: LÓGICA DE FILTRAR PRATOS ---
    const dishes = useMemo(() => {
        // Se 'Todos' está selecionado, retorna tudo
        if (selectedCategory === 'all') {
            return allDishes;
        }
        // Senão, filtra...
        return allDishes.filter(dish => {
            // Verifica se o prato tem o array 'categorias' E
            // se esse array 'inclui' a categoria selecionada
            return dish.categorias && dish.categorias.includes(selectedCategory);
        });
    }, [allDishes, selectedCategory]);

    const handleSelectCategory = useCallback((category) => {
        setSelectedCategory(category);
    }, []);

    return { 
        dishes, // Lista já filtrada
        categories,
        selectedCategory,
        handleSelectCategory,
        isLoading, 
        error 
    };
}